import LearnPageLayout from "@/components/LearnPageLayout";
import { page5DayTms } from "./learnData5DayTms";

const FiveDayTmsPage = () => (
  <LearnPageLayout
    title={page5DayTms.title}
    description={page5DayTms.description}
    canonical={page5DayTms.canonical}
    h1={page5DayTms.h1}
    breadcrumbLabel={page5DayTms.breadcrumbLabel}
    crumbs={page5DayTms.crumbs}
    shortAnswer={page5DayTms.shortAnswer}
    keyTakeaways={page5DayTms.keyTakeaways}
    sections={page5DayTms.sections}
    faqs={page5DayTms.faqs}
    sources={page5DayTms.sources}
    schemaJson={page5DayTms.schemaJson}
    relatedLinks={page5DayTms.relatedLinks}
    reviewBlock={page5DayTms.reviewBlock}
  />
);

export default FiveDayTmsPage;
